import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { getField, updateField } from "vuex-map-fields";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [],
  state: {
    viewContent: {
      LetsGetStarted: {},
      PeopleQuestion: {},
      Categories: [], // this contains the categories and an array of questions
      Summary: {},
      Finished: {},
      EmailModal: {},
    },
    config: {
      baseUrl: "",
      currentStep: 0,
      currentStepName: "Your Home",
      currentView: "LetsGetStartedView",
      emailStatus: {
        sent: false,
        error: false,
      },
    },
    submission: {
      peopleQuestion: "",
      savingsQuestionAnswers: [],
      email: "",
    },
  },
  getters: {
    getField,
    /* get number of slides, this includes the hardcoded start and end slides */
    getSlidesCount: (state) => {
      //count starts at 2 as we alwyas have atleast 2 slides  PeopleQuestionView, SummaryView
      let count = 2;
      state.viewContent.Categories.forEach((category) => {
        category.Questions.forEach((question) => {
          count++;
        });
      });
      return count;
    },
    getQuestionAnswerById: (state) => (Id) => {
      return state.submission.savingsQuestionAnswers.find(
        (questionAnswer) => questionAnswer.Id === Id
      );
    },
    getSavingsAmountWithMultiplier: (state) => (question) => {
      let multiplier = 1;
      if (!question.ApplyPeopleMultiplier) {
        return parseFloat(question.SavingsAmount);
      }
      switch (state.submission.peopleQuestion) {
        case "1-2 PEOPLE":
          multiplier = question.OnetoTwoPeopleMultiplier;
          break;
        case "3 PEOPLE":
          multiplier = question.ThreePeopleMultiplier;
          break;
        case "4 PEOPLE":
          multiplier = question.FourPeopleMultiplier;
          break;
        case "5+ PEOPLE":
          multiplier = question.FivePlusPeopleMultiplier;
          break;
        default:
          multiplier = 1;
          break;
      }
      return parseFloat(question.SavingsAmount) * parseFloat(multiplier);
    },
    /* Get the total savings as a number for only the questions answered and that have savings */
    getAnnualSavingsTotal: (state, getters) => {
      let total = 0;
      state.submission.savingsQuestionAnswers.forEach((questionAnswer) => {
        if (
          questionAnswer.SavingsAssociatedWith == questionAnswer.selectedValue
        ) {
          total += parseFloat(
            getters.getSavingsAmountWithMultiplier(questionAnswer)
          );
        }
      });
      return total;
    },
    /* This getter returns all the results as categories with the questions they have answered and only if they contian savings */
    getAnnualSavingsResults: (state, getters) => {
      let results = [];

      results.push({
        category: "Your Home",
        answers: [
          {
            QuestionSummaryText: state.submission.peopleQuestion,
            SavingsAmountMultiplierApplied: null,
          },
        ],
      });

      //loop through all categories
      state.viewContent.Categories.forEach((category) => {
        let answers = [];
        //loop through all questions in category
        //we want to match on if the question has been answsered and if the answer has savings
        category.Questions.forEach((question) => {
          let matchQuestionFromAnswers =
            state.submission.savingsQuestionAnswers.find(
              (questionAnswer) => questionAnswer.Id === question.Id
            );
          if (matchQuestionFromAnswers) {
            if (
              matchQuestionFromAnswers.SavingsAssociatedWith ==
              matchQuestionFromAnswers.selectedValue
            ) {
              answers.push({
                QuestionSummaryText:
                  matchQuestionFromAnswers.QuestionSummaryText,
                SavingsAmountMultiplierApplied:
                  getters.getSavingsAmountWithMultiplier(
                    matchQuestionFromAnswers
                  ),
                QuestionTipFromSelected:
                  matchQuestionFromAnswers.selectedValue == "Yes"
                    ? matchQuestionFromAnswers.AnswerYes
                    : matchQuestionFromAnswers.AnswerNo,
              });
            }
          }
        });
        if (answers.length > 0) {
          results.push({
            category: category.Name,
            answers: answers,
          });
        }
      });
      return results;
    },
  },
  mutations: {
    updateField,
    /* Updating the answer for each question, this is saved in a seperate array as we only need to track the questions they answer */
    updateQuestionAnswer: (state, question) => {
      let questionIndex = state.submission.savingsQuestionAnswers.findIndex(
        (q) => q.Id === question.Id
      );
      if (questionIndex > -1) {
        Vue.set(
          state.submission.savingsQuestionAnswers,
          questionIndex,
          question
        );
      } else {
        state.submission.savingsQuestionAnswers.push(question);
      }
    },
    /* Reset the calculator back to beginning */
    resetCalculator: (state) => {
      state.config.currentStep = 0;
      state.config.currentView = "LetsGetStartedView";      
      state.config.emailStatus.sent = false;
      state.config.emailStatus.error = false;


      state.submission = {
        peopleQuestion: "",
        savingsQuestionAnswers: [],
        email: "",
      };
    },
  },
  actions: {
    /* Updating the current step by direction. This is used for the slider */
    updateCurrentStepByDirection({ state, getters }, value) {
      if (value == "next") {
        if (state.config.currentStep < getters.getSlidesCount) {
          state.config.currentStep++;
        }
      } else if (value == "prev") {
        if (state.config.currentStep > 0) {
          state.config.currentStep--;
        }
      }
    },
    /* Post email and summary back to server to send an email to the user */
    async sendEmail({ state, getters }) {
      let endpoint =
        window.location.origin + window.location.pathname + "/email";
      let payload = {
        results: getters.getAnnualSavingsResults,
        email: state.submission.email,
        annualSavingsTotal: getters.getAnnualSavingsTotal,
      };
      return await axios
        .post(endpoint, payload)
        .then((res) => {
          state.config.emailStatus.sent = true;
          state.config.emailStatus.error = false;
        })
        .catch((error) => {
          state.config.emailStatus.sent = true;
          state.config.emailStatus.error = true;
          throw error;
        });
    },
  },
});
